import { useScrollReveal } from "@/hooks/useScrollReveal";
import SectionTitle from "./SectionTitle";

const galleryImages = [
  {
    src: "/images/GRANSTARK-staff1.jpeg",
    alt: "GRANSTARKの警備スタッフ集合写真",
  },
  {
    src: "/images/GRANSTARK-staff2.jpeg",
    alt: "夜間現場で活躍するGRANSTARKの警備スタッフ",
  },
  {
    src: "/images/GRANSTARK-staff3.jpeg",
    alt: "交通誘導を行うGRANSTARKの警備スタッフ",
  },
  {
    src: "/images/GRANSTARK_event(businesss.html).jpg",
    alt: "夜間イベント警備を行うGRANSTARKスタッフ",
  },
  {
    src: "/images/GRANSTARK-staff7_private.jpeg",
    alt: "GRANSTARKスタッフの懇親会の様子",
  },
];

export default function RecruitOfficeSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section className="bg-white py-16 md:py-24" id="office">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto" ref={ref}>
        <div
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <SectionTitle en="OFFICE" ja="職場風景" />
          <p className="text-gray-600 leading-loose max-w-4xl mx-auto text-center mb-10 text-sm md:text-base">
            規律と秩序を守りながらも、楽しく自由にをモットーにしている当社。社長やリーダー陣が率先して、風通しが良く、働きやすい環境づくりを進めています。
            現在、登録ベースで約130名、レギュラーで50〜60名のスタッフが在籍。中心となっているのは50代・60代ですが、現場の隊長クラスとなると、20代・30代の若手が多く活躍しています。年齢に関わらず、意欲のある方にはキャリアアップの道も用意されており、最近では20代の女性も入社し、多様なメンバーが活躍しています。
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {galleryImages.map((img, i) => (
              <div
                key={i}
                className={`rounded-xl overflow-hidden ${i === 0 ? "col-span-2 md:col-span-1" : ""}`}
              >
                <div className="h-48 md:h-56 w-full">
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}